import { useData } from '@app/data/repositories';
import { QuickScanScreen } from './QuickScanScreen';
import { useQuickScan } from './useQuickScan';

/**
 * Вход быстрого скана: знает про данные и навигацию, сам экран — нет.
 * Та же граница, что у `QuickScanRoute` на Android.
 */
export function QuickScanRoute({
  photo,
  onShot,
  onSaved,
  onBack,
}: {
  photo: File | null;
  onShot: (photos: File[]) => void;
  /** Куда положили — туда и открываем: юрист снимал не в пустоту. */
  onSaved: (caseId: string) => void;
  onBack: () => void;
}) {
  const { db, files } = useData();
  const { state, save } = useQuickScan(db, files);

  return (
    <QuickScanScreen
      photo={photo}
      state={state}
      onShot={onShot}
      onBack={onBack}
      onSave={(choice) => {
        void save(choice).then((caseId) => {
          if (caseId) onSaved(caseId);
        });
      }}
    />
  );
}
